'use strict';

import {eventEmitter, sessid, lang} from '../common/baseData';

class RatingVoteItem {
    constructor(params) {
        this.params = params;
        this.loadUrl = '/local/components/webhome/rating.vote/vote.ajax.php';
    }

    isUserAuthorizedUser() {
        return this.params.hasOwnProperty('IS_AUTHORIZED') ? this.params['IS_AUTHORIZED'] : false;
    }

    getUserId() {
        if(!localStorage.getItem('ratingUserId')) {
            if(!this.params.hasOwnProperty('USER_ID') || !this.params['USER_ID'])
                return 0;
            localStorage.setItem('ratingUserId', this.params['USER_ID']);
        }
        return Number(localStorage.getItem('ratingUserId'));
    }

    /** @return integer **/
    getUserVote() {
        let result = 0;
        let encodedString = localStorage.getItem('userVoteData');
        if(encodedString) {
            let userVoteData = JSON.parse(atob(encodedString));
            if(userVoteData.hasOwnProperty(this.params['ENTITY_TYPE_ID'])
                && userVoteData[this.params['ENTITY_TYPE_ID']].hasOwnProperty(this.params['ENTITY_ID']))
                result = Number(userVoteData[this.params['ENTITY_TYPE_ID']][this.params['ENTITY_ID']]);
        }
        return result;
    }

    setUserVote(value) {
        let encodedString = localStorage.getItem('userVoteData');
        let userVoteData = (encodedString) ? JSON.parse(atob(encodedString)) : {};

        if(!userVoteData.hasOwnProperty(this.params['ENTITY_TYPE_ID']))
            userVoteData[this.params['ENTITY_TYPE_ID']] = {};

        if(!userVoteData[this.params['ENTITY_TYPE_ID']].hasOwnProperty())
            userVoteData[this.params['ENTITY_TYPE_ID']][this.params['ENTITY_ID']] = 0;

        userVoteData[this.params['ENTITY_TYPE_ID']][this.params['ENTITY_ID']] = value;

        localStorage.setItem('userVoteData', btoa(JSON.stringify(userVoteData)));
    }

    sendVote(type) {
        let action = (type === 'like') ? 'plus' : 'minus';
        let userVote = this.getUserVote();

        if((userVote !== 0)
            && (userVote > 0 && type === 'like') || (userVote < 0 && type === 'dislike')) {
            action = 'cancel';
        }

        let data = {
            'RATING_VOTE': 'Y',
            'RATING_RESULT': 'Y',
            'RATING_VOTE_TYPE_ID': this.params['ENTITY_TYPE_ID'],
            'RATING_VOTE_ENTITY_ID': this.params['ENTITY_ID'],
            'RATING_VOTE_ACTION': action,
            'RATING_VOTE_REACTION': type,
            'USER_ID': this.getUserId()
        };

        return this.sendRequest(data)
            .then(response => {
                return response.json();
            })
            .then(result => {
                let extResult = {status: false};
                if(!result || Object.keys(result).length <= 0)
                    return extResult;

                extResult.status = true;

                if(result.hasOwnProperty('resultVotes') && result.resultVotes) {
                    let voteNum = 0;
                    if(result.action === 'plus')
                        voteNum = 1;
                    else if(result.action === 'minus')
                        voteNum = -1;

                    this.setUserVote(voteNum);
                } else {
                    this.setUserVote(0);
                }


                if(result.action === 'cancel')
                    extResult.action = 'cancel';
                else
                    extResult.action = (result.action === 'plus') ? 'like' : 'dislike';

                extResult.like = result.resultPositiveVotes;
                extResult.dislike = result.resultNegativeVotes;

                return extResult;
            });
    }

    sendRequest(data) {
        let formData = new FormData();
        formData.append('sessid', sessid);
        formData.append('lang', lang);

        for (let i in data) {
            if (!data.hasOwnProperty(i) || i === 'loadUrl') continue;
            formData.append(i, data[i]);
        }

        return fetch((data.hasOwnProperty('loadUrl')) ? data.loadUrl : this.loadUrl, {body: formData, method: 'POST'});
    }

}

export {RatingVoteItem};